module.exports = __webpack_public_path__ + "img/Logo_circle.92069ed4.png";